import { PDialog } from '@apigrowfinance/pbolt-dialog';
import { FormattedMessage } from 'react-intl';

import { CustomerDetails } from '@clients/customersClient';
import UserEditForm from '@pages/accountDetail/tabs/users/user/userEditModal/UserEditForm';

interface UserEditModalProps {
    customerDetails: CustomerDetails;
    onClickClose: () => void;
    onClickSave: () => void;
}

const UserEditModal = ({
    customerDetails,
    onClickClose,
    onClickSave,
}: UserEditModalProps) => {
    return (
        <PDialog
            open
            dialogTitle={
                <FormattedMessage
                    id="userEditDialog.editDetails"
                    defaultMessage="Edit details"
                />
            }
            dialogSubtitle={
                <FormattedMessage
                    id="phoneEditDialog.editDetailsSubheader"
                    defaultMessage="You can edit the details by changing the input fields below then clicking save."
                />
            }
            onClose={onClickClose}>
            <UserEditForm
                customerDetails={customerDetails}
                onClickClose={onClickClose}
                onClickSaved={onClickSave}
            />
        </PDialog>
    );
};

export default UserEditModal;
